export function normalizeForTestId(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '-')
        .replace(/-+/g, '-')
        .replace(/(^-+)|(-+$)/g, '');
}
export function createTestId(...parts) {
    return parts
        .filter(part => part !== null && part !== undefined && part !== '')
        .map(part => normalizeForTestId(String(part)))
        .filter(part => part.length > 0)
        .join('-');
}
export function capitalize(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    return str
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}
export function camelCase(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+(.)/g, (_, char) => char.toUpperCase());
}
export function kebabCase(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '-')
        .replace(/-+/g, '-')
        .replace(/(^-+)|(-+$)/g, '');
}
export function snakeCase(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/([a-z])([A-Z])/g, '$1_$2')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '_')
        .replace(/_+/g, '_')
        .replace(/(^_+)|(_+$)/g, '');
}
export function slugify(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-')
        .replace(/(^-+)|(-+$)/g, '');
}
export function truncate(str, maxLength, suffix = '...') {
    if (!str || typeof str !== 'string') {
        return '';
    }
    if (str.length <= maxLength) {
        return str;
    }
    return str.slice(0, maxLength - suffix.length) + suffix;
}
export function mask(str, pattern) {
    if (!str || !pattern) {
        return str || '';
    }
    let result = '';
    let strIndex = 0;
    let patternIndex = 0;
    while (strIndex < str.length && patternIndex < pattern.length) {
        const patternChar = pattern[patternIndex];
        const strChar = str[strIndex];
        if (patternChar === '#') {
            if (/\d/.test(strChar)) {
                result += strChar;
                strIndex++;
                patternIndex++;
            }
            else {
                strIndex++;
            }
        }
        else if (patternChar === '*') {
            result += strChar;
            strIndex++;
            patternIndex++;
        }
        else {
            result += patternChar;
            patternIndex++;
        }
    }
    return result;
}
